"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentKindSchema = exports.ComponentKind = exports.LabelJustificationSchema = exports.LabelJustification = exports.PortAlignmentSchema = exports.PortAlignment = exports.PortStyleSchema = exports.PortStyle = exports.TextFrameAlignmentSchema = exports.TextFrameAlignment = exports.SheetSymbolSideSchema = exports.SheetSymbolSide = exports.PortIOTypeSchema = exports.PortIOType = exports.OffSheetConnectorStyleSchema = exports.OffSheetConnectorStyle = exports.PowerPortStyleSchema = exports.PowerPortStyle = exports.FillModeSchema = exports.FillMode = exports.LineWidthSchema = exports.LineWidth = exports.JustificationSchema = exports.Justification = exports.PinLengthSchema = exports.PinLength = exports.ElectricalTypeSchema = exports.ElectricalType = exports.CoordinateSchema = exports.ColorSchema = exports.PortOrientationSchema = exports.PortOrientation = exports.OrientationSchema = exports.Orientation = void 0;
exports.convertPowerPortOrientation = convertPowerPortOrientation;
exports.isKnownComponentKind = isKnownComponentKind;
exports.preprocessEnumValue = preprocessEnumValue;
const zod_1 = require("zod");
var Orientation;
(function (Orientation) {
    Orientation[Orientation["Rotate0"] = 0] = "Rotate0";
    Orientation[Orientation["Rotate90"] = 1] = "Rotate90";
    Orientation[Orientation["Rotate180"] = 2] = "Rotate180";
    Orientation[Orientation["Rotate270"] = 3] = "Rotate270";
})(Orientation || (exports.Orientation = Orientation = {}));
exports.OrientationSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(Orientation));
var PortOrientation;
(function (PortOrientation) {
    PortOrientation[PortOrientation["RIGHTWARDS"] = 0] = "RIGHTWARDS";
    PortOrientation[PortOrientation["UPWARDS"] = 1] = "UPWARDS";
    PortOrientation[PortOrientation["LEFTWARDS"] = 2] = "LEFTWARDS";
    PortOrientation[PortOrientation["DOWNWARDS"] = 3] = "DOWNWARDS";
})(PortOrientation || (exports.PortOrientation = PortOrientation = {}));
exports.PortOrientationSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(PortOrientation));
function convertPowerPortOrientation(val) {
    switch (val) {
        case PortOrientation.RIGHTWARDS:
            return Orientation.Rotate180;
        case PortOrientation.UPWARDS:
            return Orientation.Rotate90;
        case PortOrientation.LEFTWARDS:
            return Orientation.Rotate0;
        case PortOrientation.DOWNWARDS:
            return Orientation.Rotate270;
    }
}
exports.ColorSchema = zod_1.z
    .object({
    r: zod_1.z.number(),
    g: zod_1.z.number(),
    b: zod_1.z.number(),
})
    .strict();
exports.CoordinateSchema = zod_1.z
    .object({
    x: zod_1.z.number(),
    y: zod_1.z.number(),
})
    .strict();
var ElectricalType;
(function (ElectricalType) {
    ElectricalType[ElectricalType["Input"] = 0] = "Input";
    ElectricalType[ElectricalType["IO"] = 1] = "IO";
    ElectricalType[ElectricalType["Output"] = 2] = "Output";
    ElectricalType[ElectricalType["OpenCollector"] = 3] = "OpenCollector";
    ElectricalType[ElectricalType["Passive"] = 4] = "Passive";
    ElectricalType[ElectricalType["HiZ"] = 5] = "HiZ";
    ElectricalType[ElectricalType["OpenEmitter"] = 6] = "OpenEmitter";
    ElectricalType[ElectricalType["Power"] = 7] = "Power";
})(ElectricalType || (exports.ElectricalType = ElectricalType = {}));
exports.ElectricalTypeSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(ElectricalType));
var PinLength;
(function (PinLength) {
    PinLength[PinLength["Short"] = 0] = "Short";
    PinLength[PinLength["Middle"] = 1] = "Middle";
    PinLength[PinLength["Long"] = 2] = "Long";
})(PinLength || (exports.PinLength = PinLength = {}));
exports.PinLengthSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(PinLength));
var Justification;
(function (Justification) {
    Justification[Justification["BottomLeft"] = 0] = "BottomLeft";
    Justification[Justification["BottomCenter"] = 1] = "BottomCenter";
    Justification[Justification["BottomRight"] = 2] = "BottomRight";
    Justification[Justification["CenterLeft"] = 3] = "CenterLeft";
    Justification[Justification["Center"] = 4] = "Center";
    Justification[Justification["CenterRight"] = 5] = "CenterRight";
    Justification[Justification["TopLeft"] = 6] = "TopLeft";
    Justification[Justification["TopCenter"] = 7] = "TopCenter";
    Justification[Justification["TopRight"] = 8] = "TopRight";
})(Justification || (exports.Justification = Justification = {}));
exports.JustificationSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(Justification));
var LineWidth;
(function (LineWidth) {
    LineWidth[LineWidth["Smallest"] = 0] = "Smallest";
    LineWidth[LineWidth["Small"] = 1] = "Small";
    LineWidth[LineWidth["Medium"] = 2] = "Medium";
    LineWidth[LineWidth["Large"] = 3] = "Large";
})(LineWidth || (exports.LineWidth = LineWidth = {}));
exports.LineWidthSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(LineWidth));
var FillMode;
(function (FillMode) {
    FillMode[FillMode["None"] = 0] = "None";
    FillMode[FillMode["Solid"] = 1] = "Solid";
    FillMode[FillMode["Transparent"] = 2] = "Transparent";
})(FillMode || (exports.FillMode = FillMode = {}));
exports.FillModeSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(FillMode));
var PowerPortStyle;
(function (PowerPortStyle) {
    PowerPortStyle[PowerPortStyle["Circle"] = 0] = "Circle";
    PowerPortStyle[PowerPortStyle["Arrow"] = 1] = "Arrow";
    PowerPortStyle[PowerPortStyle["Bar"] = 2] = "Bar";
    PowerPortStyle[PowerPortStyle["Wave"] = 3] = "Wave";
    PowerPortStyle[PowerPortStyle["PowerGround"] = 4] = "PowerGround";
    PowerPortStyle[PowerPortStyle["SignalGround"] = 5] = "SignalGround";
    PowerPortStyle[PowerPortStyle["Earth"] = 6] = "Earth";
    PowerPortStyle[PowerPortStyle["GostArrow"] = 7] = "GostArrow";
    PowerPortStyle[PowerPortStyle["GostPowerGround"] = 8] = "GostPowerGround";
    PowerPortStyle[PowerPortStyle["GostEarth"] = 9] = "GostEarth";
    PowerPortStyle[PowerPortStyle["GostBar"] = 10] = "GostBar";
})(PowerPortStyle || (exports.PowerPortStyle = PowerPortStyle = {}));
exports.PowerPortStyleSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(PowerPortStyle));
var OffSheetConnectorStyle;
(function (OffSheetConnectorStyle) {
    OffSheetConnectorStyle[OffSheetConnectorStyle["LeftArrow"] = 0] = "LeftArrow";
    OffSheetConnectorStyle[OffSheetConnectorStyle["RightArrow"] = 1] = "RightArrow";
})(OffSheetConnectorStyle || (exports.OffSheetConnectorStyle = OffSheetConnectorStyle = {}));
exports.OffSheetConnectorStyleSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(OffSheetConnectorStyle));
var PortIOType;
(function (PortIOType) {
    PortIOType[PortIOType["Unspecified"] = 0] = "Unspecified";
    PortIOType[PortIOType["Output"] = 1] = "Output";
    PortIOType[PortIOType["Input"] = 2] = "Input";
    PortIOType[PortIOType["Bidirectional"] = 3] = "Bidirectional";
})(PortIOType || (exports.PortIOType = PortIOType = {}));
exports.PortIOTypeSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(PortIOType));
var SheetSymbolSide;
(function (SheetSymbolSide) {
    SheetSymbolSide[SheetSymbolSide["Left"] = 0] = "Left";
    SheetSymbolSide[SheetSymbolSide["Right"] = 1] = "Right";
    SheetSymbolSide[SheetSymbolSide["Top"] = 2] = "Top";
    SheetSymbolSide[SheetSymbolSide["Bottom"] = 3] = "Bottom";
})(SheetSymbolSide || (exports.SheetSymbolSide = SheetSymbolSide = {}));
exports.SheetSymbolSideSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(SheetSymbolSide));
var TextFrameAlignment;
(function (TextFrameAlignment) {
    TextFrameAlignment[TextFrameAlignment["Left"] = 1] = "Left";
    TextFrameAlignment[TextFrameAlignment["Center"] = 2] = "Center";
    TextFrameAlignment[TextFrameAlignment["Right"] = 3] = "Right";
})(TextFrameAlignment || (exports.TextFrameAlignment = TextFrameAlignment = {}));
exports.TextFrameAlignmentSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(TextFrameAlignment));
var PortStyle;
(function (PortStyle) {
    PortStyle[PortStyle["NoneHorizontal"] = 0] = "NoneHorizontal";
    PortStyle[PortStyle["Left"] = 1] = "Left";
    PortStyle[PortStyle["Right"] = 2] = "Right";
    PortStyle[PortStyle["LeftRight"] = 3] = "LeftRight";
    PortStyle[PortStyle["NoneVertical"] = 4] = "NoneVertical";
    PortStyle[PortStyle["Top"] = 5] = "Top";
    PortStyle[PortStyle["Bottom"] = 6] = "Bottom";
    PortStyle[PortStyle["TopBottom"] = 7] = "TopBottom";
})(PortStyle || (exports.PortStyle = PortStyle = {}));
exports.PortStyleSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(PortStyle));
var PortAlignment;
(function (PortAlignment) {
    PortAlignment[PortAlignment["Center"] = 0] = "Center";
    PortAlignment[PortAlignment["Right"] = 1] = "Right";
    PortAlignment[PortAlignment["Left"] = 2] = "Left";
})(PortAlignment || (exports.PortAlignment = PortAlignment = {}));
exports.PortAlignmentSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(PortAlignment));
var LabelJustification;
(function (LabelJustification) {
    LabelJustification[LabelJustification["BottomLeft"] = 0] = "BottomLeft";
    LabelJustification[LabelJustification["BottomCenter"] = 1] = "BottomCenter";
    LabelJustification[LabelJustification["BottomRight"] = 2] = "BottomRight";
    LabelJustification[LabelJustification["CenterLeft"] = 3] = "CenterLeft";
    LabelJustification[LabelJustification["CenterCenter"] = 4] = "CenterCenter";
    LabelJustification[LabelJustification["CenterRight"] = 5] = "CenterRight";
    LabelJustification[LabelJustification["TopLeft"] = 6] = "TopLeft";
    LabelJustification[LabelJustification["TopCenter"] = 7] = "TopCenter";
    LabelJustification[LabelJustification["TopRight"] = 8] = "TopRight";
})(LabelJustification || (exports.LabelJustification = LabelJustification = {}));
exports.LabelJustificationSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(LabelJustification));
var ComponentKind;
(function (ComponentKind) {
    ComponentKind[ComponentKind["Standard"] = 0] = "Standard";
    ComponentKind[ComponentKind["Mechanical"] = 1] = "Mechanical";
    ComponentKind[ComponentKind["Graphical"] = 2] = "Graphical";
    ComponentKind[ComponentKind["NetTieInBOM"] = 3] = "NetTieInBOM";
    ComponentKind[ComponentKind["NetTieNoBOM"] = 4] = "NetTieNoBOM";
    ComponentKind[ComponentKind["StandardNoBOM"] = 5] = "StandardNoBOM";
    ComponentKind[ComponentKind["Jumper"] = 6] = "Jumper";
})(ComponentKind || (exports.ComponentKind = ComponentKind = {}));
exports.ComponentKindSchema = zod_1.z.preprocess(preprocessEnumValue, zod_1.z.nativeEnum(ComponentKind));
const componentKindValues = new Set(Object.values(ComponentKind).filter((value) => typeof value === 'number'));
function isKnownComponentKind(value) {
    return componentKindValues.has(value);
}
function preprocessEnumValue(val) {
    if (typeof val === 'string') {
        if (/^\d+$/.test(val)) {
            return parseInt(val, 10);
        }
    }
    return val;
}
//# sourceMappingURL=AltiumEnums.js.map